import { Injectable } from "@angular/core";
import { AuthService } from "../auth/auth.service";
import { Router } from "@angular/router";
import { MessageService } from "primeng/api";
import { BaseApiService } from "../../api/base";
import { BehaviorSubject } from "rxjs";

export interface Stats {
  companiesTotal: number;
  companiesPipeline: number;
  companiesPriority: number;
  companiesEnriched: number;
  companiesElevation: number;
  totalInteractions: number;
  autoElevations: number;
}

export enum StatsType {
  PIPELINE = "companiesTotal",
  INTERACTIONS = "totalInteractions",
  PRIORITY = "companiesPriority",
  ENRICHED = "companiesEnriched",
  ELEVATION = "companiesElevation",
  AUTO_ELEVATIONS = "autoElevations",
}

export interface TabStats {
  label: string;
  type: StatsType;
  total: number;
  currentTotal?: number;
}

@Injectable({
  providedIn: "root",
})
export class TabStatsService extends BaseApiService<Stats> {
  private stats: Stats | undefined = undefined;
  private tabStats: TabStats | undefined = undefined;
  private StatsLabel: any = {
    companiesTotal: "Companies",
    totalInteractions: "Interactions (Last 3 Months)",
    companiesElevation: "Elevations",
  };

  tabStatistics = new BehaviorSubject<TabStats | undefined>(undefined);

  constructor(authService: AuthService, router: Router, messageService: MessageService) {
    super("/dashboard", authService, router, messageService);
  }

  public get tabStats$() {
    return this.tabStats;
  }

  init(type: StatsType, total?: number, label?: string) {
    if (this.stats) {
      this.tabStats = {
        label: this.StatsLabel[type] ?? label,
        type,
        total: this.stats[type] ?? total,
      };

      this.tabStatistics.next(this.tabStats);
    } else {
      this.get("/stats").subscribe((response) => {
        if (response.data) {
          this.stats = response.data;

          this.tabStats = {
            label: this.StatsLabel[type] ?? label,
            type,
            total: this.stats[type] ?? total,
          };

          this.tabStatistics.next(this.tabStats);
        }
      });
    }
  }

  update(currentTotal: number) {
    if (this.tabStats) {
      this.tabStats.currentTotal = currentTotal;
      this.tabStatistics.next(this.tabStats);
    }
  }

  destroy() {
    this.tabStats = undefined;
    this.tabStatistics.next(undefined);
  }
}
